<template>
  <section>
    <div v-if="isMetric"> 
      <router-link :to="{ name: 'MetricSeason', params: {key: seasonKey}}"> Season</router-link>
      <router-link :to="{ name: 'MetricSeasonSchedule', params: {key: seasonKey}}">Schedule</router-link>
      <router-link :to="{ name: 'MetricSeasonPoints', params: {key: seasonKey}}">Points Table</router-link>
      <router-link :to="{ name: 'MetricSeasonStats', params: {key: seasonKey}}">Stats</router-link>
    </div>
    <div v-else>
      <router-link :to="{ name: 'cricketSeason', params: {key: seasonKey}}"> Season</router-link>
      <router-link :to="{ name: 'cricketSeasonSchedule', params: {key: seasonKey}}">Schedule</router-link>
      <router-link :to="{ name: 'cricketSeasonPoints', params: {key: seasonKey}}">Points Table</router-link>
      <router-link :to="{ name: 'cricketSeasonStats', params: {key: seasonKey}}">Stats</router-link>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    seasonKey: String,
    showSeason: {
      type: Boolean,
      default: false
    },
    isMetric: {
      type: Boolean,
      default: false
    }
  }
}
</script>
